export default {
	place: 'Clasificación',
	project_name: 'Electrolux Instala',
	user: 'E-mail',
	platform_meta_description:
		'Eleve sua expertise como instalador com nossos cursos online gratuitos, fornecidos pela Electrolux. Aprimore suas habilidades, obtenha certificados valiosos e conquiste vantagens exclusivas. Junte-se a uma comunidade de profissionais apaixonados por excelência na instalação!',
}
